import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
    { path: '', redirectTo: 'portal', pathMatch: 'full'},
    { path: 'inicio', loadChildren: () => import('app/inicio/inicio.module').then(m => m.InicioModule) },
    { path: 'portal', loadChildren: () => import('app/portal/portal.module').then(m => m.PortalModule) },
    { path: 'finalizar', loadChildren: () => import('app/finalizar/finalizar.module').then(m => m.FinalizarModule) }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
